// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/vapor/_Checkbox.scss
// module id = 388
// module chunks = 88 89